<template>
  <div class="page_wrapper container-fluid lecture_area">
    <div class="row page_header lecture_header">
      <lectures-header
        :title-ch="'工作坊'"
        :title-en="'Workshop'"
      />
    </div>
    <div class="row lecture_index_content">
      <lectures-index-content
        :lecture-type="'workshop'"
        :title-ch="'工作坊'"
        :title-en="'Workshop'"
      />
    </div>
  </div>
</template>
<script>
import LecturesHeader from '~components/pages/lectures/LecturesHeader'
import LecturesIndexContent from '~components/pages/lectures/LecturesContent'
import '~style/pages/lecture.scss'
export default {
  name: 'LectureWorkshop',
  routerName: 'LecturesWorkshop',
  components: {
    LecturesHeader,
    LecturesIndexContent
  }
}
</script>
